import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LocalizationForm from '../LocalizationForm/LocalizationForm';
import { useModals } from 'hooks/useModals';
import { TLocalizationEdit } from './LocalizationEdit.types';
import { useAppDispatch } from 'store/store';
import { STATIC_LOCALIZATION_FORM_DEFAULT_VALUES } from '../LocalizationForm/constants';
import { TLocalizationFormValues } from '../LocalizationForm/LocalizationForm.types';
import { getLocalizationFormSchema } from '../LocalizationForm/LocalizationForm.schema';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

const LocalizationEdit: TLocalizationEdit = ({ item }) => {
  const localize = useLocalize();
  const dispatch = useAppDispatch();
  const modals = useModals();

  const localizationFormSchema = React.useMemo(
    () => getLocalizationFormSchema(localize),
    [localize]
  );

  const form = useForm<TLocalizationFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: { ...STATIC_LOCALIZATION_FORM_DEFAULT_VALUES, ...item },
    resolver: yupResolver(
      localizationFormSchema
    ) as Resolver<TLocalizationFormValues>,
  });

  const handleSubmit = (data: TLocalizationFormValues) => {
    // dispatch(
    //   updateLocalizationAsyncThunk({
    //     id: item.id,
    //     body: { ...data, id: item.id },
    //     onSuccess: () => {
    //       modals.closeModal();
    //       dispatch(getLocalizationListAsyncThunk());
    //     },
    //   })
    // );
  };

  return (
    <FormProvider {...form}>
      <LocalizationForm onSubmit={handleSubmit} />
    </FormProvider>
  );
};

export default LocalizationEdit;
